var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-4 detail_header",staticStyle:{"font-size":"24px"}},[_c('div',[_vm._v(_vm._s(_vm.$props.title))]),_c('div',{staticClass:"ml-3"},[_vm._v("จำนวน "),_c('b',{staticClass:"ml-3 mr-3"},[_vm._v(_vm._s(_vm.number_format(_vm.$props.count)))]),_vm._v(_vm._s(_vm.$props.type))])])
}
var staticRenderFns = []

export { render, staticRenderFns }